import React from 'react';
import { bool, node, oneOf, string } from 'prop-types';
import cx from 'classnames';

import CardAction from './CardAction';
import CardBody from './CardBody';
import CardHeader from './CardHeader';
import CardIcon from './CardIcon';
import CardLabel from './CardLabel';
import CardTitle from './CardTitle';

const propTypes = {
  bordered: bool,
  className: string,
  children: node.isRequired,
  color: oneOf([
    'primary',
    'secondary',
    'green',
    'blue',
    'orange',
    'red',
    'dark-green',
  ]),
};

const defaultProps = {
  bordered: false,
  className: null,
  color: null,
};

const Card = ({ bordered, className, children, color }) => {
  const classes = cx('c-card', className, {
    'c-card--color-primary': color === 'primary',
    'c-card--color-secondary': color === 'secondary',
    'c-card--color-green': color === 'green',
    'c-card--color-blue': color === 'blue',
    'c-card--color-orange': color === 'orange',
    'c-card--color-red': color === 'red',
    'c-card--color-dark-green': color === 'dark-green',
    'c-card--bordered': bordered,
  });

  return <div className={classes}>{children}</div>;
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

Card.Action = CardAction;
Card.Body = CardBody;
Card.Header = CardHeader;
Card.Icon = CardIcon;
Card.Label = CardLabel;
Card.Title = CardTitle;

export default Card;
